import React from 'react';
import { useOverlay } from '#component/general/list-filter/hooks/useOverlayContext';
import {
  ButtonsContainer,
  ButtonWrapper,
  LeftButtonWrapper,
  LeftButton,
  LightTextButton
} from './styles';

function FilterDoubleButtons({
  firstLabel,
  secondLabel,
  onFirstButtonClick,
  onSecondButtonClick,
  isSecondButtonDisabled
}) {
  const { isOverlayOpen } = useOverlay();

  return (
    <ButtonsContainer style={isOverlayOpen ? { display: 'none' } : {}}>
      <LeftButtonWrapper>
        <LeftButton
          color="inherit"
          aria-label="Cancel"
          variant="contained"
          onClick={onFirstButtonClick}
        >
          {firstLabel}
        </LeftButton>
      </LeftButtonWrapper>
      <ButtonWrapper>
        <LightTextButton
          color="secondary"
          aria-label="Apply"
          variant="contained"
          onClick={onSecondButtonClick}
          disabled={isSecondButtonDisabled}
        >
          {secondLabel}
        </LightTextButton>
      </ButtonWrapper>
    </ButtonsContainer>
  );
}

export default FilterDoubleButtons;
